import { render, staticRenderFns } from "./saasUpgrade__list.vue?vue&type=template&id=873fdb5a"
import script from "./saasUpgrade__list.vue?vue&type=script&lang=js"
export * from "./saasUpgrade__list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports